import { Component, OnInit, ViewChild } from '@angular/core';
import {TareasApiService} from '../../../../../service/api/tareas-api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DashboardService} from '../../../../../service/events/dashboard.service';
import {BaseForm} from '../../../../base-form';
import {AppFormRequest} from '../../../../app-common/form-request/app-form-request';
import { environment } from 'src/environments/environment';
import { InputType } from 'src/app/common/components/form-builder/form-builder.component';
import { RequestButtonComponent } from 'src/app/common/components/request-button/request-button.component';
import { build, list, pool } from 'src/app/common/classes/request-builder';
import { FormRequestTypes } from 'src/app/common/classes/form-request';
import { FincasApiService } from 'src/app/service/api/fincas-api.service';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { Utils } from 'src/app/common/utils';
import { SiexApiService } from 'src/app/service/api/siex-api.service';
import moment from 'moment';

import { AgroambientalModel } from 'src/app/models/tareas/agroambientales.model';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { TratamientosModel } from 'src/app/models/tratamientos/tratamientos.model';
import { MaquinariaModel } from 'src/app/models/trabajadores/maquinaria.model';
import { ItemInterface, TypeAheadInterface } from '../../../../../common/components/form-builder/form-builder.component';

import { OptionsComponent } from 'src/app/common/components/upload-file/upload-file.component';

@Component({
    selector: 'app-agroambientales-form',
    standalone: false,
    templateUrl: './agroambientales-form.component.html',
    styleUrls: ['./agroambientales-form.component.scss']
})
export class AgroambientalesFormComponent  extends BaseForm<AgroambientalModel>  implements OnInit{

    @ViewChild(RequestButtonComponent) requestButton = new RequestButtonComponent<AgroambientalModel>();

    today = new Date();
  
    public formRequest = new AppFormRequest<AgroambientalModel>();

    public parcelasName = environment.features.parcelasName;
    
    public tipoSuperficieParcelas = environment.features.hasSuperficieCultivada
        ? 'Sup.\xa0Cultivada'
        : 'S.\xa0Sigpac';

    public textoSuperficie = environment.features.textoSuperficie;

    public appName = environment.appName;

    showDialogUploadFile = false;

    public override model: AgroambientalModel = {};

    public tratamientosList: TypeAheadInterface<TratamientosModel> = list(['...', null]);

    public unidadList: TypeAheadInterface<string> = list(['...', null]);

    public listFincas: TypeAheadInterface<FincasModel> = list();

    public listSectores: TypeAheadInterface<SectorModel[]> = list();

    public listParcelas: TypeAheadInterface<ParcelasModel> = list();

    public listMaquinaria: TypeAheadInterface<MaquinariaModel> = list();

    public listEspeciesAnimales: TypeAheadInterface<{ id: string | number; especies_animales: string }> = list();

    public tipoEcorregimenList: TypeAheadInterface<string> = list('...','Leñosos', 'Arroz', 'Pastoreo');

    public tareas_labor: TypeAheadInterface<string> = list(['...', null],
        'Fangueo',
        'Hacer Márgenes',
        'Trailla',
        'Láser',
        'Cultivador',
        'Rotovator',
        'Multiapero',
        'Paquete de trabajo 1',
        'Paquete de trabajo 2',
        'Desbroce Cursos de Agua'
    );

    optionsUploadFile: OptionsComponent = {
        name: 'u_' + (environment.features.hasClients ? StorageManager.getClient()?.id : StorageManager.getUser()?.id),
        directory: 'ecorregimenes',
        multiple: false,
        accept: '.pdf',
        maxFileSize: 2000000,
        mode: 'advanced',
        uploaded: this.model.adjunto_guia ? true : false,
        uploadedFilesNames: [],
        url: environment.serverUrl + 'ws/index.php?p1=upload&p2=upload_file&folder=ecorregimenes',
        uploadFunction: this.uploadFile.bind(this)
    };

    handleNamesFilesOutput(event: string): void {
        this.model.adjunto_guia = event;   
    }

    handleEventUpload(event: { originalEvent: any; files: File[]; }): void {
        if(event.files.length > 0){
            this.model.adjunto_guia = event.files.map(file => file.name).join(', ');
            this.optionsUploadFile.uploaded = true;
        }
    }

    public actividadesSobreCubierta: TypeAheadInterface<{codigo_SIEX: string, actividad: string}> = list();

    public formFieldsPlaces: ItemInterface<object>[] = [
        { 
            field: 'id_finca', 
            label: this.appName === 'avafitogest' ? 'Explotación' : 'Finca', 
            inputType: {type: InputType.DROPDOWN_SEARCH }, 
            values: this.listFincas,
            valuePrimaryKey: 'id',
            required: true,
     
        },
        { 
            field: 'id_sector',
            label: 'Sector',
            inputType: { type: InputType.DROPDOWN_MULTISELECT_SEARCH },
            valuePrimaryKey: 'id',
            multiSelect: true,
            canSelectAll: true,
            values: this.listSectores,
            filter: (it: { value: SectorModel}) => {
                if (this.listFincas.selected) {
                    return it.value.id_finca === (this.listFincas.selected.id ?? '');
                } else {
                    return false;
                }
            },
        },
        { 
            field: 'id_parcelas', 
            label: this.parcelasName, 
            inputType: {type: InputType.DROPDOWN_MULTISELECT_SEARCH }, 
            multiSelect: true,
            canSelectAll: true,
            values: this.listParcelas,
            valuePrimaryKey: 'id',
            filter: (it: { value: ParcelasModel}) => {
                if (it.value.activo?.toString() !== '1') {
                    return false;
                }
                if (this.listSectores.selected && this.listSectores.selected.length > 0) {
                    return this.listSectores.selected
                        .map((sector: SectorModel) => sector.id)
                        .includes(it.value.id_sector ?? '');
                }
                if (this.listFincas.selected) {
                    return it.value.id_finca === (this.listFincas.selected.id ?? '');
                }
                
                return false;
            },
            required: true
        },
        {
            field: 'tipo_ecorregimen',
            label: 'Tipo de Registro Ecorrégimen',
            inputType: { type: InputType.DROPDOWN },
            values: this.tipoEcorregimenList
        }
    ];

    public formFields: ItemInterface<object>[] = [
    
        { 
            field: 'fecha_establecimiento_cv', 
            label: 'Fecha Establecimiento Cubierta Vegetal', 
            inputType: { type: InputType.CALENDAR },
            calendarConfiguration: {
                minDate: environment.appName === 'avafitogest' ? 
                    new Date(new Date().getFullYear(), 2, 15) : undefined,
                maxDate: environment.appName === 'avafitogest' ? 
                    new Date(new Date().getFullYear(), 10, 15) : undefined,
            }
        },
        { 
            field: 'anchura_cv', 
            label: 'Anchura Cubierta Vegetal (m)', 
            inputType: { type: InputType.EDIT_NUMERIC } 
        },
        { 
            field: 'tipo_mantenimiento_cv', 
            label: 'Tipo Mantenimiento Cubierta Vegetal', 
            inputType: { type: InputType.DROPDOWN },
            values: this.actividadesSobreCubierta,
            valuePrimaryKey: 'codigo_SIEX'
        },
        {
            field: 'anchura_libre_proyeccion_1',
            label: 'Anchura Libre Proyeccion Copa (m)',
            inputType: { type: InputType.EDIT_NUMERIC } 
        }
    ];

    public formFieldsCubiertasInertes: ItemInterface<object>[] = [
        { 
            field: 'fecha_establecimiento_ci', 
            label: 'Fecha Establecimiento Cubierta Inerte', 
            inputType: { type: InputType.CALENDAR },
            calendarConfiguration: {
                minDate: environment.appName === 'avafitogest' ? 
                    new Date(new Date().getFullYear(), 0, 31) : undefined,
                maxDate: environment.appName === 'avafitogest' ? 
                    new Date(new Date().getFullYear(), 4, 15) : undefined,
            }
        },
        { 
            field: 'anchura_ci', 
            label: 'Anchura Cubierta Inerte (m)', 
            inputType: { type: InputType.EDIT_NUMERIC } 
        },
        { 
            field: 'anchura_libre_proyeccion_2', 
            label: 'Anchura libre de la Proyección Copa (m) ', 
            inputType: { type: InputType.EDIT_NUMERIC } 
        },
    ];

    public formFieldsArroz: ItemInterface<object>[] = [
        { 
            field: 'fecha_arroz', 
            label: 'Fecha Arroz', 
            inputType: { type: InputType.CALENDAR } 
        },
        { 
            field: 'labor', 
            label: 'Labor', 
            inputType: { type: InputType.DROPDOWN }, 
            values: this.tareas_labor 
        },
        { 
            field: 'tipo_operacion', 
            label: 'Tipo Operación', 
            inputType: { type: InputType.DROPDOWN },
            values: list('', 'Escarda química', 'Desbroce mecánico'), 
        },
        { 
            field: 'id_maquinaria', 
            label: 'Maquinaria', 
            inputType: { type: InputType.DROPDOWN }, 
            values: this.listMaquinaria,
            valuePrimaryKey: 'id'
        },
        { 
            field: 'observaciones', 
            label: 'Observaciones', 
            inputType: { type: InputType.EDIT_TEXTAREA } 
        },
    ];

    formFieldsArroz2: ItemInterface<object>[] = [
        {
            field: 'fecha_siembra',
            label: 'Fecha Siembra',
            inputType: { type: InputType.CALENDAR },
        },
        {
            field: 'dosis_siembra',
            label: 'Dosis Siembra',
            inputType: { type: InputType.EDIT_NUMERIC },
        },
        {
            field: 'fecha_arroz',
            label: 'Fecha Recolección',
            inputType: { type: InputType.CALENDAR },
        },
        {
            field: 'fecha_nivelacion',
            label: 'Fecha Nivelación',
            inputType: { type: InputType.CALENDAR },
        },
        {
            field: 'fecha_seca_inicio_intermitente',
            label: 'Fecha Inicio Seca Intermitente',
            inputType: { type: InputType.CALENDAR },
        },
        {
            field: 'fecha_seca_fin_intermitente',
            label: 'Fecha Fin Seca Intermitente',
            inputType: { type: InputType.CALENDAR }
        },
        {
            field: 'fecha_inicio_inundacion_cultivo',
            label: 'Fecha Inicio Inundación del Cultivo',
            inputType: { type: InputType.CALENDAR },
            calendarConfiguration: {
                minDate:
                    environment.appName === 'avafitogest'
                        ? new Date(new Date().getFullYear(), 4, 5)
                        : undefined,
                maxDate:
                    environment.appName === 'avafitogest'
                        ? new Date(new Date().getFullYear(), 4, 14)
                        : undefined,
            },
        },
        {
            field: 'fecha_fin_inundacion_cultivo',
            label: 'Fecha Fin Inundación del Cultivo',
            inputType: { type: InputType.CALENDAR },
            calendarConfiguration: {
                minDate:
                    environment.appName === 'avafitogest'
                        ? new Date(new Date().getFullYear(), 7, 16)
                        : undefined,
                maxDate:
                    environment.appName === 'avafitogest'
                        ? new Date(new Date().getFullYear(), 7, 24)
                        : undefined,
            },
        },
        {
            field: 'fecha_inicio_inundacion_invernal',
            label: 'Fecha Inicio Inundación Invernal',
            inputType: { type: InputType.CALENDAR },
            calendarConfiguration: {
                minDate:
                    environment.appName === 'avafitogest'
                        ? new Date(new Date().getFullYear(), 10, 4)
                        : undefined,
                maxDate:
                    environment.appName === 'avafitogest'
                        ? new Date(new Date().getFullYear(), 10, 14)
                        : undefined,
            },
        },
        {
            field: 'fecha_fin_inundacion_invernal',
            label: 'Fecha Fin Inundación Invernal',
            inputType: { type: InputType.CALENDAR },
            calendarConfiguration: {
                minDate:
                    environment.appName === 'avafitogest'
                        ? new Date(new Date().getFullYear(), 0, 16)
                        : undefined,
                maxDate:
                    environment.appName === 'avafitogest'
                        ? new Date(new Date().getFullYear(), 0, 25)
                        : undefined,
            },
        }
    ];

    formFieldsPastoreoExtensivo: ItemInterface<Object>[] = [
        {
            field: 'fecha_inicio_pastoreo_extensivo',
            label: 'Fecha Inicio Pastoreo Extensivo',
            inputType: { type: InputType.CALENDAR }
        },
        {
            field: 'fecha_fin_pastoreo_extensivo',
            label: 'Fecha Fin Pastoreo Extensivo',
            inputType: { type: InputType.CALENDAR }
        },
        {
            field: 'especie',
            label: 'Especie',
            inputType: { type: InputType.DROPDOWN_SEARCH },
            values: this.listEspeciesAnimales,
            valuePrimaryKey: 'id'
        },
        {
            field: 'rega',
            label: 'REGA',
            inputType: { type: InputType.EDIT_TEXT }
        },
        {
            field: 'numero_animales',
            label: 'Número de Animales',
            inputType: { type: InputType.EDIT_NUMERIC }
        }
    ];

    formFieldsPastoreoIslasBiodiversidad: ItemInterface<Object>[] = [
        {
            field: 'fecha_siega_1',
            label: 'Siega: 1er Fecha Corte',
            inputType: { type: InputType.CALENDAR }
        },
        {
            field: 'fecha_siega_2',
            label: 'Siega: 2do Fecha Corte',
            inputType: { type: InputType.CALENDAR }
        },
        {
            field: 'fecha_siega_3',
            label: 'Siega: 3er Fecha Corte',
            inputType: { type: InputType.CALENDAR }
        },
        {
            field: 'fecha_laboreo',
            label: 'Fecha Laboreo',
            inputType: { type: InputType.CALENDAR }
        },
        {
            field: 'fecha_siembra',
            label: this.appName === 'avafitogest' ? 'Fecha Mantenimiento' : 'Fecha Siembra',
            inputType: { type: InputType.CALENDAR }
        },
        {
            field: 'otras_actividades',
            label: this.appName === 'avafitogest' ? 'Observaciones Mantenimiento' : 'Otras Actividades',
            inputType: { type: InputType.EDIT_TEXTAREA }
        }
    ];


    requestType: FormRequestTypes = 0;


    constructor(public override dashboard: DashboardService,                 
        public tareasApi: TareasApiService,
        public override route: ActivatedRoute,
        public override router: Router,
        public fincasApi: FincasApiService,
        public siexApi: SiexApiService,
    ) { 
        super(
            route,
            router,
            dashboard,
            tareasApi.agroambientales.PUT,
            tareasApi.agroambientales.POST,
            'tareas-agroambientales',
            `Editar Tarea ${environment.features.moduleNameEcorregimenesOrAgroAmbiental[0] ?? 'Agroambientales'}`,
            `Añadir datos ${environment.features.moduleNameEcorregimenesOrAgroAmbiental[0] ?? 'Agroambientales'}`,
            `Duplicar tareas ${environment.features.moduleNameEcorregimenesOrAgroAmbiental[0] ?? 'Agroambientales'}`
        ); 
    }

    ngOnInit(): void {
        this.initFormData();
        this.expandFormRequest();        

        this.formRequest
            .setType(this.getType())
            .setModel(this.model)
            .setRegisterId(this.getRegisterId())
            .setGetRequest(this.tareasApi.agroambientales.GET)
            .setPostRequest(this.tareasApi.agroambientales.POST)
            .setPutRequest(this.tareasApi.agroambientales.PUT)
            .setFormFields(this.formFields)
            .setFieldsToSend(
                (['id', 'nombre_mantenimiento', 'adjunto_guia', 'nombre_especie'])
                    .concat(
                        this.formFieldsPlaces.map(it => it.field ?? '')
                    )
                    .concat(
                        this.formFields.map(it => it.field ?? '')
                    ).concat(
                        this.formFieldsCubiertasInertes.map(it => it.field ?? '')
                    ).concat(
                        this.formFieldsArroz.map(it => it.field ?? '')
                    ).concat(
                        this.formFieldsArroz2.map(it => it.field ?? '')
                    ).concat(
                        this.formFieldsPastoreoExtensivo.map(it => it.field ?? '')
                    ).concat(
                        this.formFieldsPastoreoIslasBiodiversidad.map(it => it.field ?? '')
                    )
            );

        this.formRequest.load();
        this.softInit(this.getType());

        this.formRequest.afterLoad(() => {
            this.optionsUploadFile.uploaded = this.model.adjunto_guia ? true : false;
            this.optionsUploadFile.uploadedFilesNames = this.model.adjunto_guia?.includes(',') ?
                this.model.adjunto_guia?.split(',') :
                this.model.adjunto_guia ? [this.model.adjunto_guia] : [];

            // Recalcular rangos de calendario según el año de los datos cargados
            if (environment.appName === 'avafitogest') {
                this.updateInundacionCalendarRanges();
                this.updateLenosCalendarRanges();
            }
        });

        this.countSuperficieParcelas();
    }

  
    ngAfterView(): void {
    
    }

   uploadFile(event: { originalEvent: any; files: File[]; }): void {
        try {
            const response = JSON.parse(event.originalEvent.body);

            if (response.code === 200) {
                console.log('Archivos subidos correctamente');
                
                this.showDialogUploadFile = false; 
            } else {
                console.error('Error:', response.message);
            }
        } catch (e: any) {
            console.error('Error parsing response:', e);
        }
    }

    formChanges(event?: string): void {
        if (event === 'id_finca') {
            this.listSectores.selected = null;
            this.listParcelas.selected = null;
            this.model.id_sector = '';
            this.model.id_parcelas = '';
            this.formRequest.update();
        }
        
        if (event === 'id_sector') {
            this.listParcelas.selected = null;
            this.model.id_parcelas = '';
            this.formRequest.update();
        }
        
        if(event === 'parcela' || event === 'id_parcelas') {
            this.countSuperficieParcelas();
        }

        if (event === 'tipo_ecorregimen') {
            this.model.tipo_ecorregimen = this.tipoEcorregimenList.selected ?? '';
        }

        if (event === 'adjunto_guia') {
            console.log(event);
            
        }
    }


    initFormData(): Promise<void> {
        return pool([
            build(this.fincasApi.fincasGET, this.listFincas, 'nombre'),
            build(this.fincasApi.sectoresGET, this.listSectores, ['nombre'], true),
            build(
                this.fincasApi.parcelasGET,
                this.listParcelas,
                this.appName === 'avafitogest' ? this.parcelaLabel : 'nombre',
                true,
                true
            ),
            build(this.siexApi.actividadesSobreCubiertaGET, this.actividadesSobreCubierta, 'actividad_sobre_la_cubierta'),
            build(this.siexApi.especiesAnimalesGET, this.listEspeciesAnimales, 'especies_animales', true)
        ], () => {

            if (this.listFincas.filtered.length === 2 && this.getType() === 0) {
                this.model.id_finca = this.listFincas.filtered[1]?.value?.id ?? '';
            }
            this.formRequest.update();

        });
    }

    submit(): void {
        
        delete this.model.parcelas_superficie;

        if (this.getType() === FormRequestTypes.DUPLICATE){
            delete this.model.id;
        }

        const parcelasSeleccionadas = this.model.id_parcelas;
        const hasParcelas = parcelasSeleccionadas && 
                        (Array.isArray(parcelasSeleccionadas) ? parcelasSeleccionadas.length > 0 : parcelasSeleccionadas !== '');
        
        if (!hasParcelas) {
            this.requestButton.error = 'Debe seleccionar al menos una parcela';
            console.error('Error: No se ha seleccionado ninguna parcela');
            setTimeout(() => {
                this.requestButton.error = '';
            }, 3000);
            return;
        }

        if (!this.formRequest.checkIfValid()) {
            this.requestButton.error = 'Hay campos obligatorios';
            console.log('Error');
            return;
        }

        // Convertir fechas de YYYY-MM-DD a DD/MM/YYYY
        for (const key in this.model) {
            if (Object.hasOwn(this.model, key)) {
                if(key.startsWith('fecha_') && (this.model as any)[key]) {
                    const fecha = (this.model as any)[key];
                    
                    // Si es un string en formato ISO (YYYY-MM-DD)
                    if (typeof fecha === 'string' && fecha.match(/^\d{4}-\d{2}-\d{2}$/)) {
                        (this.model as any)[key] = moment(fecha, 'YYYY-MM-DD', true).format('DD/MM/YYYY');
                    }
                    // Si es un objeto Date
                    else if (fecha instanceof Date) {
                        (this.model as any)[key] = moment(fecha).format('DD/MM/YYYY');
                    }
                    // Si ya está en formato DD/MM/YYYY, dejarlo tal cual
                    else if (typeof fecha === 'string' && fecha.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                        (this.model as any)[key] = fecha;
                    }
                }
            }
        }

        if (this.actividadesSobreCubierta.selected) {
            this.model.nombre_mantenimiento = this.actividadesSobreCubierta.selected.actividad;
        }

        if (this.listEspeciesAnimales.selected) {
            (this.model as any).nombre_especie =
                (this.listEspeciesAnimales.selected as any).especies_animales;
        }

        this.formRequest.send();
    }

    public selectAll(): void {
        this.countSuperficieParcelas();
    }

    public getObservaciones( event: string ): void {
        this.model.observaciones = event; 
    }

    public countSuperficieParcelas(): void {
        this.model.parcelas_superficie = this.getTotalSuperficieParcelas();
        this.model.parcelas_superficie = Utils.decimalFormat(
            this.model.parcelas_superficie,
            2,
            '.',
            ',',
            3
        );
    
        const idxParcelas = this.getItemPosition(this.formFieldsPlaces, 'id_parcelas');
    
        (
                this.formFieldsPlaces[
                    idxParcelas
                ] as ItemInterface<ParcelasModel>
        ).label =
                this.parcelasName +
                ' (' +
                this.tipoSuperficieParcelas +
                ':\xa0' +
                this.model.parcelas_superficie +
                '\xa0' +
                this.textoSuperficie +
                ')';
    }

    private getTotalSuperficieParcelas(): number {
        return (this.listParcelas.selected as any || [])
            .filter(
                (it: ParcelasModel) =>
                    it && (it.superficie_cultivada || it.superficie_sigpac)
            )
            .map((it: ParcelasModel) =>
                parseFloat(
                    ((it.superficie_cultivada ?? 0) || it.superficie_sigpac || 0)
                        .toString()
                        .replace(',', '.')
                )
            )
            .reduce((a: number, b: number) => a + b, 0);
    }
    
  
    private expandFormRequest(): void {

        this.formRequest.beforeLoad(resolve => {
            this.initFormData().then(() => {
                resolve(true);
                return;
            }).catch ((e:any) => {
                console.error('catch en formRequest: ' + e);
            });
        });

        this.formRequest.beforeSend(resolve => {
            for (const f of [
                'fecha_establecimiento_cv', 'fecha_establecimiento_ci',
                'fecha_arroz',
                'fecha_inicio_pastoreo_extensivo', 'fecha_fin_pastoreo_extensivo',
                'fecha_inicio_inundacion_cultivo', 'fecha_fin_inundacion_cultivo',
                'fecha_inicio_inundacion_invernal', 'fecha_fin_inundacion_invernal',
                'fecha_seca_inicio_intermitente','fecha_seca_fin_intermitente',
                'fecha_siega_1', 'fecha_siega_2', 'fecha_siega_3',
                'fecha_laboreo', 'fecha_siembra', 'fecha_nivelacion'
            ]) {
                const v = (this.model as any)[f];

                (this.model as any)[f] = v ? Utils.formatDate(v) : (v ?? '');
            }

            if (StorageManager.getUser().tipo === 'comunero') {
                this.model.id_cliente = StorageManager.getUser().id_cliente ?? '';
            } else {
                const clientId = (StorageManager.getClient()?.id ?? '');
                const clientIdFromForm = this.model.id_cliente;
                
                this.model.id_cliente = clientIdFromForm ?? clientId ?? '';
            }
            
            const userId = StorageManager.getUser().id;
            const userIdFromForm = this.model.id_usuario;

            this.model.id_usuario = userIdFromForm ?? userId ?? '';
      
            setTimeout(() => {
                this.countSuperficieParcelas();
            }, 100);  
            resolve(true);
        });
    }

    private parcelaLabel = (p: ParcelasModel) => {
        const nombre = (p.nombre ?? '').toString().trim();
        const variedad = (p.variedad ?? 'SIN VARIEDAD').toString().trim();

        let zonaRiegoAbrev = '';
        if ((p.cultivo ?? '').toLowerCase() === 'arroz') {
            const zr = (p.zona_riego ?? '').toString().toLowerCase();
            if (zr.includes('alta')) zonaRiegoAbrev = 'ZA';
            else if (zr.includes('baja')) zonaRiegoAbrev = 'ZB';
        }

        const variedadConZona = zonaRiegoAbrev
            ? `${variedad} - ${zonaRiegoAbrev}`
            : variedad;

        const pol = (p.poligono ?? '').toString().trim();
        const num = (p.numero ?? '').toString().trim();
        const rec = (p.recinto ?? '').toString().trim();
        const codigos = [pol, num, rec].filter(Boolean).join('-');

        const supRaw = (p.superficie_cultivada ?? p.superficie_sigpac ?? p.superficie ?? '0').toString();
        const supNum = parseFloat(supRaw.replace(',', '.')) || 0;
        const supFmt = supNum.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

        const uds = environment.features.textoSuperficie || 'ha';

        const derecha = [codigos || undefined, `${supFmt} ${uds}`]
            .filter(Boolean)
            .join(' · ');

        return `${nombre} - ${variedadConZona} — ${derecha}`;
    };

    private updateInundacionCalendarRanges(): void {
        const clearRange = (field: string) => {
            const i = this.formFieldsArroz2.findIndex(f => f.field === field);
            if (i >= 0) {
                (this.formFieldsArroz2[i] as any).calendarConfiguration = {
                    minDate: undefined,
                    maxDate: undefined,
                };
            }
        };

        // En edición o duplicado, no restringir rangos
        if (this.getType() !== FormRequestTypes.CREATE) {
            clearRange('fecha_inicio_inundacion_cultivo');
            clearRange('fecha_fin_inundacion_cultivo');
            clearRange('fecha_inicio_inundacion_invernal');
            clearRange('fecha_fin_inundacion_invernal');
            return;
        }

        // Solo en CREATE aplicar rangos con año actual
        const year = new Date().getFullYear();

        const idx = (field: string) =>
            this.formFieldsArroz2.findIndex(f => f.field === field);

        const setRange = (field: string, minMonth: number, minDay: number, maxMonth: number, maxDay: number) => {
            const i = idx(field);
            if (i >= 0) {
                (this.formFieldsArroz2[i] as any).calendarConfiguration = {
                    minDate: new Date(year, minMonth, minDay),
                    maxDate: new Date(year, maxMonth, maxDay),
                };
            }
        };

        setRange('fecha_inicio_inundacion_cultivo',  4, 5,  4, 14);
        setRange('fecha_fin_inundacion_cultivo',      7, 16, 7, 24);
        setRange('fecha_inicio_inundacion_invernal', 10, 4, 10, 14);

        const iInv = idx('fecha_fin_inundacion_invernal');
        if (iInv >= 0) {
            (this.formFieldsArroz2[iInv] as any).calendarConfiguration = {
                minDate: new Date(year + 1, 0, 16),
                maxDate: new Date(year + 1, 0, 25),
            };
        }
    }

    private updateLenosCalendarRanges(): void {
        const clearRange = (formFieldsArray: ItemInterface<object>[], field: string) => {
            const i = formFieldsArray.findIndex(f => f.field === field);
            if (i >= 0) {
                (formFieldsArray[i] as any).calendarConfiguration = {
                    minDate: undefined,
                    maxDate: undefined,
                };
            }
        };

        // En edición o duplicado, quitar restricciones de rango
        if (this.getType() !== FormRequestTypes.CREATE) {
            clearRange(this.formFields, 'fecha_establecimiento_cv');
            clearRange(this.formFieldsCubiertasInertes, 'fecha_establecimiento_ci');
        }
    }
}